import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSunbit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.41358 0.400391C6.28844 0.485981 5.23159 0.815846 4.29593 1.33707L6.15575 4.55838C6.26353 4.74506 6.49918 4.81035 6.69946 4.73062C6.82396 4.68106 6.95196 4.63841 7.08298 4.60313C7.27164 4.55234 7.41358 4.38798 7.41358 4.1926V0.400391Z",
			fill: "#202328"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.63298 1.75234C2.75563 2.36668 2.01363 3.16112 1.46065 4.08199L4.68255 5.94215C4.86899 6.0498 5.10543 5.98885 5.23897 5.81998C5.30928 5.73107 5.38379 5.64564 5.46221 5.56398C5.5952 5.4255 5.63278 5.21609 5.53677 5.04981L3.63298 1.75234Z",
			fill: "#202328"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.09295 4.77241C0.712523 5.58502 0.471277 6.4758 0.399902 7.41407H4.23157C4.40417 7.41407 4.54995 7.28718 4.59301 7.12004C4.63535 6.95573 4.57089 6.78039 4.42394 6.69555L1.09295 4.77241Z",
			fill: "#202328"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5999 7.41407C15.5233 6.40742 15.2512 5.45543 14.8215 4.59599L11.5558 6.48144C11.382 6.58177 11.312 6.79474 11.3697 6.98691C11.3793 7.01891 11.3884 7.0511 11.3972 7.08347C11.448 7.27213 11.6123 7.41407 11.8077 7.41407H15.5999Z",
			fill: "#202328"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4363 3.91564C13.8348 2.96983 13.0306 2.16557 12.0848 1.56405L10.2108 4.80984C10.1075 4.98885 10.1594 5.21537 10.315 5.35146C10.4336 5.45522 10.5452 5.56683 10.6489 5.68546C10.785 5.84107 11.0116 5.89294 11.1906 5.78958L14.4363 3.91564Z",
			fill: "#202328"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4045 1.17891C10.545 0.749112 9.59294 0.476972 8.58623 0.400391V4.1926C8.58623 4.38798 8.72817 4.55234 8.91682 4.60313C8.94925 4.61186 8.98149 4.62105 9.01354 4.63067C9.20572 4.6884 9.4187 4.61835 9.51903 4.44457L11.4045 1.17891Z",
			fill: "#202328"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.399902 8.58594C0.480291 9.64269 0.776162 10.6392 1.24368 11.5317L4.48898 9.65797C4.66821 9.5545 4.73643 9.33204 4.6696 9.13618C4.64497 9.06399 4.62263 8.99075 4.60264 8.91653C4.55185 8.72788 4.38749 8.58594 4.19212 8.58594H0.399902Z",
			fill: "#202328"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.64155 12.2046C2.20751 13.0587 2.94095 13.7921 3.79503 14.3581L5.68062 11.0921C5.78086 10.9185 5.73524 10.6992 5.58925 10.5618C5.53726 10.5129 5.48677 10.4624 5.43784 10.4104C5.30043 10.2644 5.08114 10.2188 4.90752 10.319L1.64155 12.2046Z",
			fill: "#202328"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.46803 14.7559C5.36043 15.2234 6.35689 15.5192 7.41358 15.5996V11.8074C7.41358 11.612 7.27164 11.4477 7.08298 11.3969C7.00882 11.3769 6.93563 11.3546 6.86349 11.33C6.66763 11.2632 6.44519 11.3314 6.34172 11.5106L4.46803 14.7559Z",
			fill: "#202328"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.58623 15.5996C9.52453 15.5282 10.4154 15.287 11.228 14.9065L9.30488 11.5756C9.22003 11.4286 9.04465 11.3641 8.88031 11.4065C8.71313 11.4496 8.58623 11.5954 8.58623 11.768V15.5996Z",
			fill: "#202328"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9184 14.5388C12.8392 13.9859 13.6336 13.2439 14.2479 12.3666L10.9504 10.4628C10.7841 10.3668 10.5747 10.4044 10.4362 10.5374C10.3546 10.6157 10.2692 10.6902 10.1804 10.7605C10.0115 10.894 9.95059 11.1305 10.0582 11.3169L11.9184 14.5388Z",
			fill: "#202328"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6632 11.7037C15.1844 10.768 15.5143 9.71111 15.5999 8.58594H11.8077C11.6123 8.58594 11.448 8.72788 11.3972 8.91654C11.3619 9.04759 11.3192 9.17562 11.2696 9.30015C11.1899 9.50044 11.2552 9.73609 11.4419 9.84387L14.6632 11.7037Z",
			fill: "#202328"
		})
	]
});
export default SvgSunbit;
